import * as z from 'zod';
import { FIRST_PAGE } from '@noor/config';

/** The transactions list defaults to 10 rows per page (cpanel `limit || 10`). */
export const TRANSACTIONS_DEFAULT_PAGE_SIZE = 10;

/**
 * Coerced + caught (never strict): the router JSON-parses search params, so a
 * bare numeric link (`?courier_id=7`) arrives as a number, and a stale value
 * must fall back to unset instead of crashing route validation.
 */
const optionalString = z.coerce.string().optional().catch(undefined);

/**
 * URL search-param schema of `/reports/transactions`. Keeps cpanel's query
 * keys (`courier_id`, `type`, `start_date`, …) so bookmarked links survive;
 * only paging moved from `limit`/`offset` to `page`/`pageSize`, like every
 * other table here.
 */
export const transactionListSearchSchema = z.object({
  /** Free-text search — sent as the transaction `display_id`. */
  search: optionalString,
  /** Day window (`YYYY-MM-DD`); unset means today. */
  start_date: optionalString,
  end_date: optionalString,
  courier_id: optionalString,
  client_id: optionalString,
  vendor_id: optionalString,
  /** Transaction type number. */
  type: optionalString,
  /** Order stage number — scopes the exported reports only. */
  stage: optionalString,
  /** Transaction status number. */
  status: optionalString,
  foul_id: optionalString,
  bonus_id: optionalString,
  page: z.coerce.number().int().positive().catch(FIRST_PAGE).default(FIRST_PAGE),
  pageSize: z.coerce
    .number()
    .int()
    .positive()
    .catch(TRANSACTIONS_DEFAULT_PAGE_SIZE)
    .default(TRANSACTIONS_DEFAULT_PAGE_SIZE),
});
export type TransactionListSearch = z.infer<typeof transactionListSearchSchema>;
